var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPoll = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 18 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 7v8H8V7ZM2 9v6H0V9Zm16-9v15h-2V0Zm-4 4v11h-2V4ZM6 4v11H4V4Z",
  className: "icon-poll_svg__cls-1"
})));
export default SvgIconPoll;